import { version } from "../../../package.json";
import { OperationsModes } from "../fields/operations-modes";
import { setApiURL } from "../lib/config";

export const PORT = process.env.VUE_APP_PORT || 8080;
export const ENVIRONMENT = process.env.NODE_ENV || "production";
export const IS_PRODUCTION = ENVIRONMENT === "production";
export const VERSION = version;

const _setOperationMode = (operationModeStr) => {
    const key = Object.keys(OperationsModes).find(
        (key) => OperationsModes[key] === operationModeStr
    );
    const operationMode = key
        ? OperationsModes[key]
        : OperationsModes.posSimpleAccess;
    return operationMode;
};

const OPERATION_MODE_STR =
    process.env.VUE_APP_OPERATION_MODE || "pos-simple-access";

export const OPERATION_MODE = _setOperationMode(OPERATION_MODE_STR);
console.log(
    "Running in [%s] operation mode [%s] environment version [%s]",
    OPERATION_MODE,
    ENVIRONMENT,
    VERSION
);
export const IS_ENABLED_ECOMMERCE_OPTIONS = [
    OperationsModes.develop,
    OperationsModes.franchise,
    OperationsModes.multiTenant,
    OperationsModes.ecommerce,
    OperationsModes.ecommerceDemo,
    OperationsModes.ecommerceBronze,
    OperationsModes.ecommerceSilver,
    OperationsModes.ecommerceGold,
    OperationsModes.ecommercePro
].includes(OPERATION_MODE);
export const IS_ONLINE = [
    OperationsModes.develop,
    OperationsModes.franchise,
    OperationsModes.multiTenant,
    OperationsModes.ecommerce,
    OperationsModes.ecommerceDemo,
    OperationsModes.ecommerceBronze,
    OperationsModes.ecommerceSilver,
    OperationsModes.ecommerceGold,
    OperationsModes.ecommercePro
].includes(OPERATION_MODE);

export const IS_CROSS_USER = [
    OperationsModes.franchise,
    OperationsModes.multiTenant,
    OperationsModes.posProtectedAccess,
    OperationsModes.posSimpleAccess
].includes(OPERATION_MODE);

export const IS_MULTI_TENANT = [OperationsModes.multiTenant].includes(
    OPERATION_MODE
);
// Modos con catálogo público propio: si tiene URL, tiene QR (no depende del
// plan). Ver requirements/qr-negocio.md del harness.
export const IS_ENABLED_CATALOG_QR = [
    OperationsModes.multiTenant,
    OperationsModes.ecommercePro
].includes(OPERATION_MODE);

export const HAS_INTERNAL_COMMISSIONS = [OperationsModes.franchise].includes(
    OPERATION_MODE
);
export const HAS_CUSTOM_SUBDOMAIN = [OperationsModes.multiTenant].includes(
    OPERATION_MODE
);
export const IS_ENABLED_FREE_AUTH = [OperationsModes.posSimpleAccess].includes(
    OPERATION_MODE
);
export const IS_ENABLE_FEDERATED_AUTH =
    [
        OperationsModes.franchise,
        OperationsModes.multiTenant,
        OperationsModes.ecommerceBronze,
        OperationsModes.ecommerceSilver,
        OperationsModes.ecommerceGold,
        OperationsModes.ecommercePro,
        OperationsModes.multiTenant
    ].includes(OPERATION_MODE) && IS_PRODUCTION;
export const SITE_TYPE = "sistema";
export const TIMEZONE = "America/Bogota";

export const TARGET_GROUP_LABELS = process.env.VUE_APP_TARGET_GROUP_LABELS
    ? JSON.parse(process.env.VUE_APP_TARGET_GROUP_LABELS)
    : {};
export const TARGET_GROUP_FILTER_LABEL =
    process.env.VUE_APP_TARGET_GROUP_FILTER_LABEL || "";

export const MARKETPLACE_API_URL = setApiURL(
    process.env.VUE_APP_FRANCHISE_API_URL
);
export const MARKETPLACE_PORTAL_URL = process.env.VUE_APP_FRANCHISE_PORTAL_URL;
export const MARKETPLACE_PORTAL_SLOGAN =
    process.env.VUE_APP_FRANCHISE_PORTAL_SLOGAN;
export const LOGIN_PAGE_HEADLINE =
    process.env.VUE_APP_FRANCHISE_PORTAL_LOGIN_HEADLINE ||
    MARKETPLACE_PORTAL_SLOGAN;
export const SHOW_LOGIN_IMAGE = process.env.VUE_APP_SHOW_LOGIN_IMAGE === "true";
export const STACK_NAME = process.env.VUE_APP_STACK_NAME;
export const FRANCHISE_URL = process.env.VUE_APP_FRANCHISE_URL;
export const FRANCHISE_DOMAIN = process.env.VUE_APP_DOMAIN_DNS || "";
export const DEFAULT_FRANCHISE_MARGIN = Number(
    process.env.VUE_APP_FRANCHISE_MARGIN | "10"
);

export const SITE_BASE_PATH = process.env.VUE_APP_SITE_BASE_PATH || "/";
export const PRIMARY_COLOR = process.env.VUE_APP_PRIMARY_COLOR || "#284D6F";
export const SECONDARY_COLOR = process.env.VUE_APP_SECONDARY_COLOR || "#C52D3D";
export const EMPHASIS_COLOR = process.env.VUE_APP_EMPHASIS_COLOR || "#FD951E";
export const DETAILS_COLOR = process.env.VUE_APP_DETAILS_COLOR || "#FDC621";

export const SITE_SUCCESS_COLOR = "#02913f";
export const SITE_DANGER_COLOR = "#e11d48";
export const SITE_WARNING_COLOR = "#f59e0b";
export const SITE_DARK_COLOR = "#1E1E1E";

export const DEFAULT_IMAGE_URL =
    process.env.VUE_APP_DEFAULT_IMAGE_URL || "/default-image.jpg";
export const PUBLIC_KEY = process.env.VUE_APP_PUBLIC_KEY.replace(/\\n/gm, "\n");

export const AUTH_REDIRECT_SIGN_IN = `${MARKETPLACE_PORTAL_URL}/callback`;
export const AUTH_REDIRECT_SIGN_OUT = `${MARKETPLACE_PORTAL_URL}/login`;
export const AWS_REGION = process.env.VUE_APP_AWS_REGION;
export const COGNITO_URL = process.env.VUE_APP_COGNITO_URL;
export const COGNITO_USERS_POOLS_ID =
    process.env.VUE_APP_COGNITO_USERS_POOLS_ID;
export const COGNITO_USERS_POOLS_WEB_CLIENT_ID =
    process.env.VUE_APP_COGNITO_USERS_POOLS_WEB_CLIENT_ID;

export const ENABLED_AUTH = OPERATION_MODE !== OperationsModes.posSimpleAccess;
export const IS_ENABLED_ENCRYPT_SIGN_IN =
    PUBLIC_KEY && OPERATION_MODE === OperationsModes.posProtectedAccess;

const _getAuthConfiguration = () => {
    if (IS_ENABLE_FEDERATED_AUTH) {
        if (
            !AWS_REGION ||
            !COGNITO_URL ||
            !COGNITO_USERS_POOLS_ID ||
            !COGNITO_USERS_POOLS_WEB_CLIENT_ID
        ) {
            console.error(
                "To operate in marketplace mode configure the environment variables for cognito"
            );
            return { enabledGoogleAuth: false, error: true };
        }
        return { enabledGoogleAuth: true, error: false };
    }
    return { enabledGoogleAuth: false, error: false };
};

const authConfiguration = _getAuthConfiguration();
export const IS_ENABLED_GOOGLE_AUTH = authConfiguration.enabledGoogleAuth;
export const LANDING_SOURCE_STORAGE_KEY = "landingSource";
// `{ plan, period }` que la landing manda en la URL del login; lo consume y
// borra el paso `plan` del onboarding.
export const LANDING_PLAN_INTENT_STORAGE_KEY = "landingPlanIntent";
export const ONBOARDING_EXIT_INTENT_STORAGE_KEY = "onboardingExitIntentShown";
export const BUSINESS_NAME = process.env.VUE_APP_BUSINESS_NAME;
export const FRANCHISE_PORTAL_TITLE = process.env.VUE_APP_BUSINESS_NAME;
export const FRANCHISE_PORTAL_DESCRIPTION =
    process.env.VUE_APP_FRANCHISE_PORTAL_DESCRIPTION;
export const FRANCHISE_PORTAL_KEYWORDS =
    process.env.VUE_APP_FRANCHISE_PORTAL_KEYWORDS;
export const LOGIN_PAGE_TITLE = `Inicio de sesión ${FRANCHISE_PORTAL_TITLE} | ${FRANCHISE_DOMAIN}`;
export const SUPPORT_WHATSAPP_LINK = "https://wa.me/573249211687";
export const LEGAL_DOCUMENTS_BASE_URL = "https://tucatalogo.co/legal";

export const ERROR_CONFIG = authConfiguration.error;

export const ENABLED_CITIES = JSON.parse(
    process.env.VUE_APP_ENABLED_CITIES ||
        '{"11001":"Bogotá D.C.","co":"Resto de Colombia"}'
);

export const STATIC_ORDER_LOGO_PATH = "/img/logos/complete_logo.png";
